<template>
  <div class="nav-footer">
    <a :class="{active:navIndex === 0}" href="/h5/index">系统首页</a>
    <a :class="{active:navIndex === 1}" href="/h5/noticeList">通知公告</a>
    <a :class="{active:navIndex === 2}" href="/h5/user">个人中心</a>
  </div>
</template>

<script>
  export default {
    name: "Nav",
    props:{
      navIndex: {
        type: Number,
        default: 0
      },
    }
  }
</script>

<style scoped lang="scss">
.nav-footer{
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-top: 1px solid #eee;
  a{
    display: block;
    width: 33.33%;
    height: 49px;
    text-align: center;
    line-height: 49px;
    font-size: 20px;
    color: #333;
    border-right: 1px solid #eee;
    &:last-child{
      border-right: 0;
    }
    &.active{
      background: #2b8ee3;
      color: #fff;
    }
  }
}
</style>